import { Link } from "react-router-dom"
import { FetchURL } from "../../../utils/url"
import SingleProduct from "../../Products/singleProduct"
import useFetch from "../../../utils/useFetch"
import Loading from "../../Loading"

const FeaturedProducts = () => {

    const { data, loading } = useFetch(FetchURL)

    const products = data.products;

    if (loading) {
        return <Loading />
    }

    
    return(
        <section id="products" className="relative min-h-screen overflow-hidden px-6 pt-32 md:px-12 lg:px-20">
            <div className="mx-auto grid min-h-[80vh] max-w-[1600px] items-center gap-12 lg:grid-cols-2">
                <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                    <div>

                        <h2 className="text-5xl font-black tracking-tighter text-gray-900 dark:text-white md:text-7xl">
                            Featured
                            <span className="text-indigo-600"> Products</span>
                        </h2>
                    </div>

                    <Link
                        to="/products"
                        className="group inline-flex items-center gap-2 w-48 rounded-3xl bg-gray-800 text-white px-4 py-2 text-sm font-semibold"
                    >
                        View All
                        <span className="transition-transform duration-300 group-hover:translate-x-1">
                            →
                        </span>
                    </Link>

                </div>

                <div className="grid grid-cols-2 gap-4">
                {products && products?.slice(0,4).map((item) => (
                    <SingleProduct 
                        key={item.id}
                        item={item}
                    />
                    ))}
                </div>
            </div>
        </section>

    )
}

export default FeaturedProducts